import {
  getDashboardLabel,
  RiskScoreEnum,
  TransactionOwnerEnum,
  TransactionStatusEnum,
  TransactionTypeEnum,
} from '@sparling/financial-common'
import { IColumns } from '../../../../../../components/Dashboard/TableSmall'
import { IColumns as IColumnsAll } from '../../../../../../components/Dashboard/Table/TableTypes'

export enum StatusTransactions {
  UnderReview = 'under_review',
  Rejected = 'rejected',
  ActionNeeded = 'action_needed',
  Approved = 'approved',
  Processing = 'processing',
}

export interface IData {
  request: string
  requestByUser?: string
  columns: IColumns[]
}

export interface IDataAll {
  request: string
  requestByUser?: string
  columns: IColumnsAll[]
}

export const data: IData = {
  request: 'transactions-history',
  requestByUser: 'transactions-history-by-user',
  columns: [
    {
      id: 'type',
      label: 'TYPE',
      format: (value: string) => value.replace('_', ' ').replace(/\b[a-z]/g, (match: string) => match.toUpperCase()),
    },
    {
      id: 'amount',
      label: 'AMOUNT',
      // format: (value: number) => `$${value}`,
    },
    {
      id: 'asset',
      label: 'ASSET',
    },
    {
      id: 'status',
      label: 'STATUS',
      format: (status, owner, type, score) =>
        getDashboardLabel(
          owner as TransactionOwnerEnum,
          status as TransactionStatusEnum,
          type as TransactionTypeEnum,
          score as RiskScoreEnum,
        ),
    },
    {
      id: 'action',
      label: 'ACTION',
      format: (value: string) => value?.replace('STATUS: ', '') || 'N/A',
    },
    {
      id: 'author',
      label: 'USER',
    },
  ],
}

export const dataAll: IDataAll = {
  request: 'transactions-history',
  requestByUser: 'transactions-history-by-user',
  columns: [
    {
      id: 'id',
      label: 'TRANSACTION ID',
    },
    {
      id: 'type',
      label: 'TYPE',
      format: (value: string) => value.replace('_', ' ').replace(/\b[a-z]/g, (match: string) => match.toUpperCase()),
    },
    {
      id: 'amount',
      label: 'AMOUNT',
      // format: (value: number) => `$${value}`,
    },
    {
      id: 'asset',
      label: 'ASSET',
    },
    {
      id: 'status',
      label: 'STATUS',
      format: (status, owner, type, score) =>
        getDashboardLabel(
          owner as TransactionOwnerEnum,
          status as TransactionStatusEnum,
          type as TransactionTypeEnum,
          score as RiskScoreEnum,
        ),
    },
    {
      id: 'action',
      label: 'ACTION',
      format: (value: string) => value?.replace('STATUS: ', '') || 'N/A',
    },
    {
      id: 'author',
      label: 'USER',
    },
    {
      id: 'createdAt',
      label: 'DATE',
      format: (value: string) =>
        value
          ? new Date(value).toLocaleString('en-GB', {
              year: 'numeric',
              month: '2-digit',
              day: '2-digit',
              hour: '2-digit',
              minute: '2-digit',
            })
          : '-',
    },
  ],
}

export const dataByUser: IDataAll = {
  request: 'transactions-history',
  columns: [
    {
      id: 'type',
      label: 'TYPE',
      // eslint-disable-next-line
      format: (value: string) => {
        return value.replace('_', ' ').replace(/\b[a-z]/g, (match: string) => match.toUpperCase())
      },
    },
    {
      id: 'amount',
      label: 'AMOUNT',
      // format: (value: number) => `$${value}`,
    },
    {
      id: 'asset',
      label: 'ASSET',
    },
    {
      id: 'status',
      label: 'STATUS',
      format: (status, owner, type, score) =>
        getDashboardLabel(
          owner as TransactionOwnerEnum,
          status as TransactionStatusEnum,
          type as TransactionTypeEnum,
          score as RiskScoreEnum,
        ),
    },
    {
      id: 'action',
      label: 'ACTION',
      // eslint-disable-next-line
      format: (value: string) => {
        return value || 'N/A'
      },
    },
  ],
}
